import counterReducer from "./counter";
import loggedReducer from "./isLogged";
import clubReducer from "./club";

import {combineReducers} from 'redux';


const allReducers = combineReducers({
    counter : counterReducer,
    logged :loggedReducer,
    currentclub :clubReducer

});

export default allReducers;